import React, { useMemo } from 'react'
import Helmet from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
// import { Flex } from '@chakra-ui/react';

import ThemeProvider from '../../contexts/chakra-ui/Provider'
import Footer from '../Footer';
import SlugContext from './slugContext';

const makeImageUrl = (imageUrl = '', siteUrl) => imageUrl.startsWith('/') ? `${siteUrl}${imageUrl}` : imageUrl

const Layout = ({ children, location, pageContext }) => {
  const { site: { siteMetadata: { title, siteUrl } } } = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
    }
  `)
  return (
    <>
      <Helmet
        defaultTitle={title}
        titleTemplate={`%s - ${title}`}
      >
        <html lang="zh-Hant-TW" />
        {pageContext?.og?.title && <title>{pageContext.og.title}</title>}
        {pageContext?.og?.description && <meta name="description" content={pageContext.og.description} />}
        {pageContext?.og?.image && <meta property="og:image" content={makeImageUrl(pageContext.og.image, siteUrl)} />}
      </Helmet>
      <SlugContext.Provider value={{ slug: pageContext.slug }}>
        <ThemeProvider override={pageContext}>
          {/* {!hideHeader && <Header height="headerHeight" hideLinks={Boolean(q)} {...headerProps[q && q[0]]} logo={q && logos[q[0]]} to={q ? `/q/${q[0]}/` : '/'} />} */}
          {children}
          <Footer location={location} pageContext={pageContext} />
        </ThemeProvider>
      </SlugContext.Provider>
    </>
  );
}

export default Layout
